import { apiFetch } from './apiClient.js';

export interface IntegrationStatus {
  id: string;
  label: string;
  status: 'ok' | 'warn' | 'err' | 'idle';
  meta?: string;
}

export interface PlatformStatusResponse {
  overall: 'ok' | 'warn' | 'err';
  generatedAt: string;
  tenantId: string;
  integrations: IntegrationStatus[];
  backend: IntegrationStatus[];
  metrics: {
    channelsTotal: number;
    channelsActive: number;
    connectorsTotal: number;
    connectorsHealthy: number;
    outboundCampaignsTotal: number;
    outboundCampaignsByStatus: Record<string, number>;
    inboundCampaignsTotal: number;
    inboundCampaignsActive: number;
  };
}

export async function getPlatformStatus(tenantId: string): Promise<PlatformStatusResponse> {
  return apiFetch<PlatformStatusResponse>(
    `/v1/tenants/${encodeURIComponent(tenantId)}/platform-status`,
  );
}
